import styled, { css } from 'styled-components';
import { NavButton } from '../Buttons';

export const StyledHeader = styled.div`
	.MuiToolbar-root {
		border-bottom: 1px #ffffff21 solid;

		${props => props.theme.breakpoints.up('xs')} {
			margin: 0% 6%;
			padding: 2px 0%;
		}
		${props => props.theme.breakpoints.up('md')} {
			margin: 0px 5%;
		}
	}

	.MuiAppBar-colorPrimary {
		background-color: transparent;
	}

	z-index: 999;
	position: fixed;
	width: 100%;

	${props =>
		!props.transparent &&
		css`
			.MuiToolbar-root {
				border-bottom: none;
			}
			.MuiAppBar-colorPrimary {
				background-color: #060505;
			}

			.nav-button:hover {
				background-color: rgba(255, 255, 255, 0.15) !important;
			}
		`}

	.MuiPaper-root {
		box-shadow: none;
	}

	${props => props.theme.breakpoints.up('xs')} {
		.nav-button,
		.inscriptionButton {
			display: none;
		}
		.signin-button {
			border-width: 0px !important;
			width: 0px !important;
			display: block;
		}
	}
	${props => props.theme.breakpoints.up('md')} {
		.nav-button,
		.inscriptionButton {
			display: block;
		}
		.signin-button {
			border-width: 2px !important;
			width: 152px !important;
			display: block;
		}
	}

	.inscriptionButton {
		margin: 0px 20px;
	}

	.switch {
		position: relative;
		display: inline-block;
		width: 60px;
		height: 34px;
		margin-left: 30px;
		margin-top: 5px;

		${props => props.theme.breakpoints.down('md')} {
			margin-left: 10px;
		}
	}

	.switch input {
		opacity: 0;
		width: 0;
		height: 0;
	}

	.slider {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #ccc;
		-webkit-transition: 0.4s;
		transition: 0.4s;
		background-color: transparent;
		border-style: solid;
		border-width: 2px;
		border-color: #81b4e1;

		:before {
			position: absolute;
			content: '';
			height: 23px;
			width: 23px;
			left: 4px;
			bottom: 4px;
			background-color: white;
			-webkit-transition: 0.4s;
			transition: 0.4s;
		}
	}

	input:focus + .slider {
		box-shadow: 0 0 1px #2196f3;
	}

	input:checked + .slider:before {
		-webkit-transform: translateX(26px);
		-ms-transform: translateX(26px);
		transform: translateX(26px);
	}

	.slider.round {
		border-radius: 34px;
	}

	.slider.round:before {
		border-radius: 50%;
		background-color: #81b4e1;
	}

	.text {
		font-size: 9px;
		cursor: pointer;
		position: absolute;
		padding-top: 11px;
	}

	.es {
		padding-left: 31px;
	}

	.en {
		padding-left: 4.5px;
	}
	.lng-color {
		color: ${props =>
			props.transparent && window.location.pathname === '/inscriptions'
				? '#2196f3'
				: '#fff'};
	}
`;

export const NavButtonHome = styled(NavButton)`
	.MuiButton-label {
		color: ${props => props.theme.label.color};
	}
	&.MuiButton-root:hover {
		background-color: rgb(210, 217, 243);
	}
`;

export const NavButtonContact = styled(NavButton)`
	margin-right: 20px !important;
	.MuiButton-label {
		color: ${props => props.theme.label.color};
	}
	&.MuiButton-root:hover {
		background-color: rgb(210, 217, 243);
	}
`;
